import type {
  BingoWidgetDataType,
  CashOfferWidgetDataType,
  ChallengeWidgetDataType,
  ChampionsTournamentWidgetDataType,
  CoinBackWidgetDataType,
  CrownRipsWidgetDataType,
  EventTriggerWidgetDataType,
  FreeSpinWidgetDataType,
  MetagameWidgetDataType,
  MonetizationWidgetDataType,
  PrizeDropWidgetDataType,
  QuestWidgetDataType,
  SnappyGiftWidgetDataType,
  StampCardWidgetDataType,
  TournamentWidgetDataType,
  UpcomingDailyMissionWidgetData,
  UpcomingMissionWidgetData,
  JackpotWidgetDataType,
  Widget as WidgetProps,
  WidgetType,
} from '../../types';
import { BingoWidget } from '../BingoWidget/BingoWidget';
import { CashOfferWidget } from '../CashOfferWidget/CashOfferWidget';
import { ChallengeWidget } from '../ChallengeWidget/ChallengeWidget';
import { ChampionsTournamentWidget } from '../ChampionsTournamentWidget/ChampionsTournamentWidget';
import { CoinBackWidget } from '../CoinBackWidget/CoinBackWidget';
import { CrownRipsWidget } from '../CrownRipsWidget/CrownRipsWidget';
import { EventTriggerWidget } from '../EventTriggerWidget/EventTriggerWidget';
import { FreeSpinsWidget } from '../FreeSpinsWidget/FreeSpinsWidget';
import { JackpotWidget } from '../JackpotWidget/JackpotWidget';
import { MetagameWidget } from '../MetagameWidget/MetagameWidget';
import { MiniGameWidget } from '../MiniGameWidget/MiniGameWidget';
import { MonetizationWidget } from '../MonetizationWidget/MonetizationWidget';
import { PrizeDropWidget } from '../PrizeDropWidget/PrizeDropWidget';
import { QuestWidget } from '../QuestWidget/QuestWidget';
import { SnappyGiftWidget } from '../SnappyGiftWidget/SnappyGiftWidget';
import { StampCardWidget } from '../StampCardWidget/StampCardWidget';
import { TournamentWidget } from '../TournamentWidget/TournamentWidget';
import { UpcomingDailyMissionWidget } from '../UpcomingDailyMissionWidget/UpcomingDailyMissionWidget';
import { UpcomingMissionWidget } from '../UpcomingMissionWidget/UpcomingMissionWidget';

export function Widget<T extends WidgetType>(props: WidgetProps<T>) {
  const { data, sizeType, type } = props;

  switch (type) {
    case 'bingo':
      return <BingoWidget data={data as BingoWidgetDataType} sizeType={sizeType} />;
    case 'challenge':
      return <ChallengeWidget data={data as ChallengeWidgetDataType} sizeType={sizeType} />;
    case 'offer':
    case 'rollingOffer':
    case 'message':
    case 'road':
      return <EventTriggerWidget data={data as EventTriggerWidgetDataType} sizeType={sizeType} />;
    case 'snappyGift':
      return <SnappyGiftWidget data={data as SnappyGiftWidgetDataType} sizeType={sizeType} />;
    case 'quest':
      return <QuestWidget data={data as QuestWidgetDataType} sizeType={sizeType} />;
    case 'stampCard':
      return <StampCardWidget data={data as StampCardWidgetDataType} sizeType={sizeType} />;
    case 'freeSpin':
      return <FreeSpinsWidget data={data as FreeSpinWidgetDataType} sizeType={sizeType} />;
    case 'miniGame':
      return <MiniGameWidget data={data as FreeSpinWidgetDataType} sizeType={sizeType} />;
    case 'crownRips':
      return <CrownRipsWidget data={data as CrownRipsWidgetDataType} sizeType={sizeType} />;
    case 'coinBack':
      return <CoinBackWidget data={data as CoinBackWidgetDataType} sizeType={sizeType} />;
    case 'hammer':
    case 'puzzle':
    case 'plinko':
    case 'roulette':
    case 'cardWar':
    case 'trail':
      return <MetagameWidget data={data as MetagameWidgetDataType} sizeType={sizeType} />;
    case 'prizeDrop':
      return <PrizeDropWidget data={data as PrizeDropWidgetDataType} sizeType={sizeType} />;
    case 'tournament':
      return <TournamentWidget data={data as TournamentWidgetDataType} sizeType={sizeType} />;
    case 'championsTournament':
      return <ChampionsTournamentWidget data={data as ChampionsTournamentWidgetDataType} sizeType={sizeType} />;
    case 'upcomingDailyMission':
      return <UpcomingDailyMissionWidget data={data as UpcomingDailyMissionWidgetData} sizeType={sizeType} />;
    case 'monetization':
      return <MonetizationWidget data={data as MonetizationWidgetDataType} sizeType={sizeType} />;
    case 'upcomingMission':
      return <UpcomingMissionWidget data={data as UpcomingMissionWidgetData} sizeType={sizeType} />;
    case 'cashOffer':
      return <CashOfferWidget data={data as CashOfferWidgetDataType} sizeType={sizeType} />;
    case 'jackpot':
      return <JackpotWidget data={data as JackpotWidgetDataType} sizeType={sizeType} />;
    default:
      return null;
  }
}
